import axios from 'axios';
import apiURL from './config';

const api = axios.create({
    baseURL: apiURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Access-Control-Allow-Origin': '*'
    }
})

export default api;